"use strict";

exports.__esModule = true;
exports.markerLabels = exports.addressOrderMap = void 0;
var _ref;
var addressOrderMap = {
  no: ['address1', 'address2', 'postalCode', 'cityPart', 'district', 'municipality'],
  nl: ['address1', 'postalCode', 'address2', 'cityPart', 'district', 'municipality'],
  us: ['address1', 'address2', 'municipality', 'postalCode']
};
exports.addressOrderMap = addressOrderMap;
var alphabet = 'abcdefghijklmnopqrstuvwxyz';
var alphabetArray = alphabet.toUpperCase().split('');
var doubleLetters = function doubleLetters(index) {
  return alphabetArray.map(function (letter) {
    return alphabetArray[index] + letter;
  });
};
var fullDoubleLetterAlphabet = alphabetArray.map(function (_, index) {
  return doubleLetters(index);
});
var markerLabels = (_ref = []).concat.apply(_ref, alphabetArray.concat(fullDoubleLetterAlphabet));
exports.markerLabels = markerLabels;